import { View } from 'backbone.marionette';
import _ from 'lodash';

import A3DeliveryScheduleGridView from '@/views/A3DeliveryScheduleGridView';

import tmplPRTNRA3DeliveryView from './PRNTRA3DeliveryView.hbs';

let isRegexValid = true;
let isZipcodeValid = true;
let isValid = true;

const PRTNRA3DeliveryView = View.extend({
  template: tmplPRTNRA3DeliveryView,

  className: 'prtnr-a3-delivery-view',

  ui: {
    deliveryGrid: '.delivery-grid',
    deliveryInfoError: '.delivery-info-error',
    zipCodeError: '.zipcode-error',
    specialCharacterError: '.special-character-error'
  },

  regions: {
    deliveryGrid: '@ui.deliveryGrid',
    deliveryInfoError: '@ui.delivery-info-error',
    zipCodeError: '@ui.zipcode-error',
    specialCharacterError: '@ui.special-character-error'
  },

  initialize() {
    const deliveryGrid = new A3DeliveryScheduleGridView({
      objectTypeCode: 'ORDER',
      objectID: this.model.get('orderDetails').orderId,
      itPOCExists: true,
      finPOCExists: true,
      gridName: 'deliveryScheduleGrid',
      model: this.model,
      editable: !this.model.get('isReadOnly')
    });
    this.showChildView('deliveryGrid', deliveryGrid);
    deliveryGrid.getViewGrid().sort('clin', 'ascending');
  },

  onRender() {
    if (!isRegexValid) {
      this.ui.specialCharacterError.show();
    }
    if (!isZipcodeValid) {
      this.ui.zipCodeError.show();
    }
    if (!isValid) {
      this.ui.deliveryInfoError.show();
    }
  },

  validate() {
    isValid = true;
    isRegexValid = true;
    isZipcodeValid = true;
    const regex = /[!@#$%^&*()_+={}[\]:;"'<>,?/\\|`~]/;
    const coll = this.getDeliveryData();
    const formType = this.model.get('orderDetails').orderTypeId;
    const reqFields = [
      'deliveryPOCName',
      'deliveryPOCEmail',
      'deliveryPOCPhone',
      'itPOCName',
      'itPOCEmail',
      'itPOCPhone',
      'finPOCName',
      'finPOCEmail',
      'finPOCPhone',
      'network',
      'addressLine1',
      'buildingFloorNumber',
      'floorNumber',
      'city',
      'regionName',
      'zip'
    ];
    const regexExclusion = [
      'deliveryPOCEmail',
      'deliveryPOCPhone',
      'itPOCEmail',
      'itPOCPhone',
      'finPOCName',
      'finPOCEmail',
      'finPOCPhone',
      'equipmentName',
      'clin',
      'additionalService',
      'branchName',
      'commandName',
      'price',
      'description',
      'volumeBand',
      'model',
      'price',
      'streetAddress',
      'commandPOCs',
      'additionalServices',
      'additionalAccessories',
      'additionalServiceText',
      'equipmentName',
      'formattedPrice'
    ];

    _.each(coll, (item) => {
      if (item.address.zip?.length > 5) {
        if (formType < 22 || formType > 26) {
          isValid = false;
          isZipcodeValid = false;
        }
      }

      if (item.isReplacementText === 'Replacement' && item.termingSerialNumber === '') {
        isValid = false;
      }

      _.forOwn(item, (value, key) => {
        if (!regexExclusion.includes(key)) {
          if (value && typeof value === 'string' && value.match(regex)) {
            isRegexValid = false;
            isValid = false;
          }
        }
      });

      _.each(reqFields, (field) => {
        if (!item[field] && !item.address[field]) {
          isValid = false;
          this.ui.deliveryInfoError.show();
        }
      });
    });

    if (!isRegexValid) {
      this.ui.specialCharacterError.show();
      this.trigger('has:errors');
    }

    if (!isZipcodeValid) {
      this.ui.zipCodeError.show();
      this.trigger('has:errors');
    }

    isValid ? this.trigger('no:errors') : this.trigger('has:errors');
    return isValid;
  },

  async getDeliveryGridCSV(isTemplate) {
    const deliveryGrid = this.getChildView('deliveryGrid');
    if (isTemplate) {
      return await deliveryGrid.downloadTemplateCSV();
    } else {
      return await deliveryGrid.generateAndDownloadCSV();
    }
  },

  getDeliveryData() {
    this.ui.deliveryInfoError.hide();
    this.ui.zipCodeError.hide();
    this.ui.specialCharacterError.hide();
    const coll = this.getChildView('deliveryGrid').model.get('schedules');
    return coll;
  }
});

export default PRTNRA3DeliveryView;
